export default "__VITE_ASSET__bc586715__"